import React from "react";
import styles from "./BodyMapPanel.module.css";
import { MdDelete } from "react-icons/md";

function BodyMapPanel({ bodyMaps = [], selectedId, onSelect, onDelete, onAdd, isLocked }) {
  return (
    <div className={`${styles.container} ${isLocked ? styles.locked : ""}`}>
      <div className={styles.sidebar}>
        <div className={styles.header}>
          <button className={styles.addButton} onClick={onAdd}>
            + Ajouter
          </button>
        </div>
        <div className={styles.thumbnails}>
          {bodyMaps.map((map) => (
            <div
              key={map.externalId}
              className={`${styles.thumbnail} ${selectedId === map.externalId ? styles.selected : ""}`}
              onClick={() => onSelect(map.externalId)}>
              <div className={styles.imageWrapper}>
                <div className={`${styles.actionMenu} `}>
                  <MdDelete
                    className={styles.actionMenuDelete}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(map);
                    }}
                  />
                </div>
                <img src={map.defaultImage} alt={map.title} title={map.title} />
              </div>
              <div className={styles.thumbnailTitle} title={map.title}>
                {map.title}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BodyMapPanel;
